(() => {
  'use strict';

  const selector = 'a[href="#zv-advies-popup"], [data-zv-advice-popup], a[href*="/pages/adviesgesprek"]';
  const cssUrl = window.ZinVoltPerformance?.adviceCss;
  const scriptUrl = window.ZinVoltPerformance?.adviceJs;
  const routesRoot = window.Shopify?.routes?.root || '/';
  let loadPromise = null;

  function loadAdvice() {
    if (loadPromise) return loadPromise;

    const cssPromise = new Promise((resolve) => {
      if (!cssUrl) {
        resolve();
        return;
      }

      const existingCss = document.querySelector('link[data-zv-advice-css]');
      if (existingCss) {
        if (existingCss.sheet) resolve();
        else {
          existingCss.addEventListener('load', resolve, { once: true });
          existingCss.addEventListener('error', resolve, { once: true });
        }
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      link.dataset.zvAdviceCss = 'true';
      link.addEventListener('load', resolve, { once: true });
      link.addEventListener('error', resolve, { once: true });
      document.head.appendChild(link);
    });

    const scriptPromise = new Promise((resolve, reject) => {
      if (!scriptUrl) {
        reject(new Error('Advice script URL missing'));
        return;
      }

      const existing = document.querySelector('script[data-zv-advice-script]');
      if (existing) {
        if (existing.dataset.loaded === 'true') resolve();
        else {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.defer = true;
      script.dataset.zvAdviceScript = 'true';
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    loadPromise = Promise.all([cssPromise, scriptPromise]);
    return loadPromise;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(selector);
    if (!trigger || trigger.dataset.zvAdviceReplay === 'true') return;
    if (document.querySelector('[data-zv-advies-modal]')?.dataset.zvAdviceReady === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    loadAdvice().then(() => {
      trigger.dataset.zvAdviceReplay = 'true';
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      trigger.removeAttribute('data-zv-advice-replay');
    }).catch(() => {
      window.location.href = trigger.href || `${routesRoot}pages/adviesgesprek`;
    });
  }, true);

  ['pointerover', 'focusin', 'touchstart'].forEach((type) => {
    document.addEventListener(type, (event) => {
      if (event.target.closest(selector)) loadAdvice().catch(() => {});
    }, { passive: type === 'touchstart', capture: true });
  });

  const isSalderingscheckPage = Boolean(document.querySelector('[data-zv-salderingscheck]'));
  const returnedFromQuickForm = new URLSearchParams(window.location.search).get('zv_advice_submitted') === '1';
  let hasPendingQuickForm = false;

  try {
    const submittedAt = Number(window.sessionStorage.getItem('zvAdviceQuickFormSubmittedAt') || 0);
    hasPendingQuickForm = submittedAt > 0 && Date.now() - submittedAt < 15 * 60 * 1000;
  } catch (error) {
    hasPendingQuickForm = false;
  }

  const hasQuickFormError = Boolean(document.querySelector('[data-zv-advice-contact-feedback="error"]'));
  if (!isSalderingscheckPage && (returnedFromQuickForm || (hasPendingQuickForm && hasQuickFormError))) {
    loadAdvice().catch(() => {});
  }
})();
